"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.color = void 0;
exports.color = {
    primary: 'rgba(0, 136, 86, 1)',
    link: '#1890ff',
    success: '#52c41a',
    warning: '#faad14',
    danger: '#f5222d',
    headText: 'rgba(0, 0, 0, 0.85)',
    text: 'rgba(0, 0, 0, 0.65)',
    secondaryText: 'rgba(0, 0, 0, 0.45)',
    disabled: 'rgba(0, 0, 0, 0.25)'
};
